// Module
var code = `<input show-errors type="tel" ng-model="answer.value" ng-model-options="{allowInvalid: true, debounce: 1000}" ng-required="block.required" class="form-control" ng-disabled="editBlock" ng-pattern="/^(\\D*\\d\\D*){10,15}\$/"/> <span class="help-block help-block-hidden" translate>Phone number must have 10-15 digits</span> `;
// Exports
var _module_exports =code;;
var path = '/views/blocks/phoneQuestion.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;